module.exports = __webpack_public_path__ + "img/40_71.fa2a7121.png";